export const TIME_ZONES_RESET_STATE = 'TIME_ZONES_RESET_STATE';
export const TIME_ZONES_CURRENT_ITEM = 'TIME_ZONES_CURRENT_ITEM';

export const TIME_ZONES_REQUEST_LOADING = 'TIME_ZONES_REQUEST_LOADING';
export const TIME_ZONES_REQUEST_SUCCESS = 'TIME_ZONES_REQUEST_SUCCESS';
export const TIME_ZONES_REQUEST_FAILED = 'TIME_ZONES_REQUEST_FAILED';

export const TIME_ZONES_CURRENT_ACTION = 'TIME_ZONES_CURRENT_ACTION';
export const TIME_ZONES_RESET_ACTION = 'TIME_ZONES_RESET_ACTION';